const escort = {
  dashboard: {
    welcome: "Bienvenido",
    dashboard_description: "Administra tu perfil, ve estadísticas y accede a acciones rápidas.",
    profile_views: "Vistas del perfil",
    new_messages: "Nuevos mensajes",
    pending_bookings: "Reservas pendientes",
    weekly_income: "Ingresos semanales",
    profile_completeness: "Integridad del perfil",
    complete_profile: "Completar perfil",
    add_photos: "Añadir fotos",
    verify_identity: "Verificar identidad",
    setup_rates: "Configurar tarifas",
    manage_services: "Administrar servicios",
    promote_profile: "Promocionar perfil",
    quick_actions: "Acciones rápidas",
    edit_profile: "Editar perfil",
    view_profile: "Ver perfil",
    manage_media: "Administrar medios",
    view_bookings: "Ver reservas",
    earnings_report: "Informe de ganancias",
    security_center: "Centro de seguridad",
    logout: "Cerrar sesión",
    profile_tips: "Consejos para el perfil",
    tip_1: "Usa fotos de alta calidad para atraer a más clientes.",
    tip_2: "Mantén tu perfil actualizado con tus últimos servicios y tarifas.",
    tip_3: "Responde a los mensajes rápidamente para aumentar las posibilidades de reserva.",
    tip_4: "Verifícate para generar confianza con los clientes potenciales.",
    all_rights_reserved: "Todos los derechos reservados",
    terms_of_service: "Términos de servicio",
    privacy_policy: "Política de privacidad",
    cookie_policy: "Política de cookies",
    accessibility: "Accesibilidad",
    contact_us: "Contáctanos",
    about_us: "Acerca de nosotros",
    faq: "Preguntas frecuentes",
    sitemap: "Mapa del sitio",
    blog: "Blog",
    social_media: "Redes sociales",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    pinterest: "Pinterest",
    newsletter: "Boletín informativo",
    subscribe: "Suscribirse",
    copyright: "Derechos de autor",
  },
  profile: {
    title: "Perfil de Escort",
    edit_profile: "Editar perfil",
    view_profile: "Ver perfil",
    profile_details: "Detalles del perfil",
    personal_info: "Información personal",
    name: "Nombre",
    age: "Edad",
    location: "Ubicación",
    availability: "Disponibilidad",
    languages: "Idiomas",
    description: "Descripción",
    services: "Servicios",
    rates: "Tarifas",
    photos: "Fotos",
    videos: "Videos",
    reviews: "Reseñas",
    contact: "Contacto",
    verify_identity: "Verificar identidad",
    identity_verified: "Identidad verificada",
    not_verified: "No verificado",
    verify_now: "Verificar ahora",
    profile_views: "Vistas del perfil",
    last_active: "Última actividad",
    member_since: "Miembro desde",
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    upload_photo: "Subir foto",
    manage_photos: "Administrar fotos",
    photos_description: "Sube fotos de alta calidad para atraer a más clientes.",
    no_photos: "Aún no hay fotos. ¡Sube tu primera foto ahora!",
    upload_first_photo: "Subir primera foto",
    profile_photo: "Foto de perfil",
    main: "Principal",
    private: "Privada",
    delete_photo: "Eliminar foto",
    set_main: "Establecer como principal",
    photo_visibility_updated: "Visibilidad de la foto actualizada",
    photo_now_public: "La foto ahora es pública",
    photo_now_private: "La foto ahora es privada",
    private_visibility: "Visibilidad privada",
    public_visibility: "Visibilidad pública",
    error_loading_photos: "Error al cargar fotos",
    try_again_later: "Por favor, inténtalo de nuevo más tarde",
    photo_uploaded: "Foto subida",
    photo_upload_success: "Foto subida con éxito",
    upload_error: "Error de subida",
    photo_deleted: "Foto eliminada",
    photo_delete_success: "Foto eliminada con éxito",
    delete_error: "Error de eliminación",
    main_photo_updated: "Foto principal actualizada",
    main_photo_update_success: "Foto principal actualizada con éxito",
    update_error: "Error de actualización",
    subscription_required: "Suscripción requerida",
    subscription_unlock: "Suscríbete para desbloquear la galería privada",
    subscribe: "Suscribirse",
    storage_unavailable: "Almacenamiento no disponible",
    storage_unavailable_message: "El servicio de almacenamiento no está disponible actualmente. No podrás subir imágenes en este momento. Por favor, inténtalo de nuevo más tarde o contacta con el soporte si este problema persiste.",
  },
  media: {
    title: "Administrador de Medios",
    description: "Administra tus fotos, videos y contenido premium.",
    public_photos: "Fotos públicas",
    videos: "Videos",
    premium_content: "Contenido premium",
    upload: "Subir",
    no_media: "Aún no hay medios. ¡Sube tu primer elemento ahora!",
    drag_drop: "Arrastra y suelta archivos aquí o haz clic para subir",
    upload_photo: "Subir foto",
    upload_video: "Subir video",
    upload_premium: "Subir contenido premium",
    sell_content: "Vender este contenido",
    price: "Precio",
    description_label: "Descripción",
    supported_formats: "Formatos soportados: JPEG, PNG, MP4",
    file_size_limit: "Límite de tamaño de archivo: 10MB",
    media_deleted: "Medio eliminado con éxito",
    set_as_private: "Establecer como privado",
    set_as_public: "Establecer como público",
    delete_media: "Eliminar medio",
    set_as_main: "Establecer como principal",
    error_loading: "Error al cargar medios",
    error_uploading_video: "Error al subir el vídeo",
  },
  security: {
    title: "Centro de Seguridad",
    description: "Gestiona la configuración de seguridad de tu cuenta.",
    change_password: "Cambiar Contraseña",
    two_factor_authentication: "Autenticación de dos factores",
    enable_2fa: "Activar autenticación de dos factores",
    disable_2fa: "Desactivar autenticación de dos factores",
    
    "2fa_enabled": "Autenticación de dos factores activada",
    "2fa_disabled": "Autenticación de dos factores desactivada",
    
    error_enabling_2fa: "Error al activar la autenticación de dos factores",
    error_disabling_2fa: "Error al desactivar la autenticación de dos factores",
  },
  rates: {
    hourly: "Tarifa por hora",
    daily: "Tarifa diaria",
    weekly: "Tarifa semanal",
    monthly: "Tarifa mensual",
    additional_services: "Servicios adicionales",
    add_service: "Añadir servicio",
    service_name: "Nombre del servicio",
    service_description: "Descripción del servicio",
    service_rate: "Tarifa del servicio",
    save_service: "Guardar servicio",
    delete_service: "Eliminar servicio",
    '30min': 'Por 30 minutos',
    '1hour': 'Por 1 hora',
  }
};

export default escort;
